<template>
  <v-row>
    <v-col cols="12">
      <BaseBlock title="Pharmacie d'officine">
        <p class="text-sm-left body-2 font-italic">
          Les informations à renseigner ne le sont qu’à titre indicatif et ne
          sauraient préjuger de l’avis qui sera émis par la commission régionale
          d’agrément.
        </p>
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-row>
            <v-col cols="5">
              <v-text-field
                v-model="dossier.officine.denomination"
                :rules="textRules"
                label="Dénomination commerciale éventuelle de la pharmacie"
                required
              ></v-text-field>
            </v-col>
            <v-col cols="3">
              <v-text-field
                v-model="dossier.officine.tel"
                :rules="telephoneRules"
                label="Téléphone"
                required
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="8">
              <v-text-field
                v-model="dossier.officine.adresse"
                :rules="textRules"
                label="Adresse"
                required
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="4">
              <v-text-field
                v-model="dossier.officine.codePostal"
                :rules="textRules"
                label="Code postal"
                required
              ></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                v-model="dossier.officine.ville"
                :rules="textRules"
                label="Ville"
                required
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="2">
              <v-text-field
                v-model="dossier.officine.superficie"
                :rules="numberRules"
                label="Superficie de l'officine (en m²)"
                required
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-select
                v-model="dossier.officine.structureAdministrative"
                :items="structuresAdministratives"
                :rules="structureAdministrativeRules"
                label="Structure administrative"
                required
              ></v-select>
            </v-col>
            <!--<v-col cols="3">
              <v-select
                v-model="dossier.officine.chiffreAffaire"
                :items="chiffresAffaire"
                label="Chiffre d’affaires de la pharmacie (facultatif)"
              ></v-select>
            </v-col>-->
          </v-row>
          <v-row>
            <v-col cols="8">
              <v-text-field
                v-model="dossier.officine.siteInternet"
                label="Adresse du site Internet de l’officine (facultatif)"
                counter="255"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="5" />
            <v-col cols="1">
              <v-btn
                color="blue"
                class="mr-4 white--text"
                @click="submit"
                :disabled="!valid"
                >Enregistrer et passer à l'étape suivante
                <v-icon>navigate_next</v-icon></v-btn
              >
            </v-col>
          </v-row>
        </v-form>
      </BaseBlock>
    </v-col>
  </v-row>
</template>

<script>
import BaseBlock from "@/components/base/BaseBlock";

export default {
  name: "Partie2",
  props: ["dossier"],
  computed: {},
  data: () => ({
    valid: true,
    structuresAdministratives: [
      "Exploitation personnelle",
      "Exploitation en société"
    ],
    chiffresAffaire: [
      "inf. à 1,3 M€ hors taxe",
      "de 1,3 à 2,6 M€ hors taxe",
      "de 2,6 à 3,9 M€ hors taxe",
      "de 3,9 à 5,2 M€ hors taxe",
      "sup. à 5,2 M€ hors taxe"
    ],
    textRules: [v => !!v || "Ce champ est requis"],
    urlRules: [v => (v !== null && v.length <= 255) || "255 caractère max."],
    structureAdministrativeRules: [
      v => !!v || "La structure administrative est requise"
    ],
    numberRules: [
      v =>
        /^-?(^[0-9]+$)$/.test(v) || "La superficie doit être un nombre entier"
    ],
    telephoneRules: [
      v => !!v || "Le numéro de téléphone est requis",
      v =>
        (v && v.length == 10) ||
        "Le numéro de téléphone doit être composé de 10 chiffres",
      v =>
        /^-?([0-9]\d*\.?\d*)$/.test(v) ||
        "Le numéro de téléphone doit être composé uniquement de chiffres"
    ]
  }),
  components: { BaseBlock },
  methods: {
    async submit() {
      if (this.$refs.form.validate()) {
        if (this.dossier.officine.siteInternet) {
          if (this.dossier.officine.siteInternet.length > 255) {
            this.$toast.error(
              "L'adresse du site Internet doit contenir 255 caractères maximum"
            );
          } else {
            this.$emit("save");
            this.$emit("nextPart");
          }
        } else {
          this.$emit("save");
          this.$emit("nextPart");
        }
      }
    }
  }
};
</script>
